import { render, staticRenderFns } from "./l-edit-key-popup.vue?vue&type=template&id=78ff97c9&scoped=true"
import script from "./l-edit-key-popup.vue?vue&type=script&lang=js"
export * from "./l-edit-key-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ff97c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ff97c9')) {
      api.createRecord('78ff97c9', component.options)
    } else {
      api.reload('78ff97c9', component.options)
    }
    module.hot.accept("./l-edit-key-popup.vue?vue&type=template&id=78ff97c9&scoped=true", function () {
      api.rerender('78ff97c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mlocalization/views/popups/l-edit-key-popup.vue"
export default component.exports